import { connect } from 'react-redux';
import Page from 'components/common/Page';
import { getPublicationsAndData } from 'redux-modules/publicationsAndData';
import { getPublicationsAndDataTitles } from 'selectors/publicationsAndData';
import { toggleMenu } from 'redux-modules/page';


const mapStateToProps = (state) => ({
  publicationsAndDataArr: getPublicationsAndDataTitles(state),
  loading: state.publicationsAndData.loading,
  error: state.publicationsAndData.error,
  menuOpen: state.page.menuOpen
});

const mapDispatchToProps = (dispatch) => ({
  getPublicationsAndData: () => dispatch(getPublicationsAndData()),
  toggleMenu: () => dispatch(toggleMenu())
});

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./app/containers/page/index.js